namespace appn.views.taskTemplates.map {

    class InitArgs {
        latLonUser: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        appn.tasks.initAddressMap({
            completeAtLot: 'Wizard_Template_Task_CompleteAtLot',
            completeAtText: 'Wizard_Template_Task_CompleteAtText',
            completeAtCountry: 'Wizard_Template_Task_CompleteAtCountry',
            completeAtLat: 'Wizard_Template_Task_CompleteAtLat',
            completeAtLon: 'Wizard_Template_Task_CompleteAtLon'
        }, _initArgs.latLonUser, true);
    }
}
